import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ArrowRight } from "lucide-react";
import { Icon } from "@iconify/react";

gsap.registerPlugin(ScrollTrigger);

export default function HeroSection() {
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const imageRef = useRef(null);
  const cardsRef = useRef([]);
  const textCircleRef = useRef();


  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(headingRef.current, {
        opacity: 0,
        y: 50,
        duration: 1.2,
        ease: "power3.out",
      });

      gsap.from(imageRef.current, {
        opacity: 0,
        x: 80,
        duration: 1.2,
        delay: 0.3,
        ease: "power3.out",
      });

      // gsap.from(cardsRef.current, {
      //   scrollTrigger: {
      //     trigger: sectionRef.current,
      //     start: "top 80%",
      //   },
      //   opacity: 0,
      //   y: 40,
      //   duration: 1,
      //   stagger: 0.2,
      //   ease: "power3.out",
      // });

      // Circular Text Rotation
      gsap.to(textCircleRef.current, {
        rotation: 360,
        duration: 15,
        repeat: -1,
        ease: "linear",
        transformOrigin: "center center",
      });

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const cards = [
    {
      id: 1,
      icon: "mdi:chart-line",
      title: "AI Confidence Analysis",
      subTitle: "Our AI analyzes interview tone, expressions, and body language to help Dubai employers assess candidate confidence, communication skills, and cultural fit beyond just resumes"
    },
    {
      id: 2,
      icon: "material-symbols:interactive-space",
      title: "AI Interview Practice",
      subTitle: "Job seekers in Dubai can practice real interview simulations with AI, improving confidence and readiness before facing actual employers."
    },
    {
      id: 3,
      icon: "material-symbols:wand-stars-outline",
      title: "AI-Generated Job & Profile Content",
      subTitle: "Create professional job descriptions and candidate bios tailored for the UAE market using AI saving time while attracting the right talent faster."
    },
    {
      id: 4,
      icon: "mdi:database-outline",
      title: "Built-In Audio & Video Interviews",
      subTitle: "Schedule and conduct secure video and audio interviews directly within the platform designed for smooth, reliable hiring across Dubai and the GCC."
    },
  ];

  return (
    <>
      {/* ====== 4 CARDS SECTION ====== */}
      <div id="features" className="w-full bg-black px-4 sm:px-10 lg:px-6 xl:px-28 xl:-bottom-130 lg:-bottom-100 lg:absolute white border-4 border-b border-x-0 border-t-0 border-neutral-100 ">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border border-b">
          {cards.map((card, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className={`bg-[0a0a0a] text-white group hover:border-b-2 border-b-white relative flex flex-col justify-center p-8 xl:h-110 lg:h-100 md:h-70  transition-all duration-500 ease-in-out border-r border-neutral-800 last:border-r-0 hover:bg-[#F26A33] hover:text-white`}
            >
              <div className="flex flex-col justify-center items-start">
                {/* ICON with rotation animation on hover */}

                <div className="transition-transform duration-500 group-hover:scale-110 mb-6  group-hover:rotate-y-[360deg]">
                  <Icon icon={card.icon} width="50" height="50" />
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold mb-4">{card.title}</h3>

                {/* Description */}
                <p className="text-sm leading-relaxed">{card.subTitle}</p>
              </div>

              {/* subtle bottom ellipse shadow */}
              <div className="absolute text bottom-12 left-1/2 -translate-x-1/2 w-[70%] h-[10px] bg-black/60 rounded-full opacity-30 blur-md group-hover:opacity-60 transition-all"></div>
            </div>
          ))}
        </div>
      </div></>
  );
}